interface ScrollToTopButtonProps {
  onClick: () => void;
  visible: boolean;
}

export function ScrollToTopButton({ onClick, visible }: ScrollToTopButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`fixed bottom-6 right-6 p-3 bg-blue-600 text-white rounded-full shadow-lg
        hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500
        transition-all duration-200 z-10
        ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}
      aria-label="Scroll to top"
    >
      <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
      </svg>
    </button>
  );
}
